// Prepínač vyberá celý frontend ešte pred načítaním jeho komponentov a CSS.
export type CheckoutVariant = 'original' | 'new'

// Údaje objednávky potrebné na výber košíka; hodnoty z API sa overujú až pri výbere
export interface OrderInfo {
  id?: unknown
  currentStepVersion?: unknown
  tpService?: unknown
}

// Poradie: nenačítaná objednávka alebo trvalý pobyt → pôvodný; ?novy_kosik=0 → pôvodný (len pre daný odkaz,
// nič sa neukladá); všetko ostatné (aj staré objednávky s verziou 0 alebo 1) → nový košík
export function selectCheckout(search: string, order: OrderInfo | null): CheckoutVariant {
  // Bez objednávky nevieme, či nejde o trvalý pobyt — nový košík ho nepozná
  if (order === null || order.tpService) {
    return 'original'
  }
  return new URLSearchParams(search).get('novy_kosik') === '0' ? 'original' : 'new'
}

// Hash objednávky je posledný neprázdny segment cesty (/orders/{hash}), presne 32 hex znakov
export function hashFromPath(pathname: string): string | null {
  const parts = pathname.split('/').filter(Boolean)
  const hash = parts[parts.length - 1] ?? ''
  return /^[0-9a-f]{32}$/i.test(hash) ? hash : null
}

// Načíta objednávku cez BFF, pri chybe raz zopakuje; null = nepodarilo sa
export async function loadOrder(hash: string, fetchFn: typeof fetch = fetch): Promise<OrderInfo | null> {
  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      const response = await fetchFn('/bff/orders/' + hash, { credentials: 'same-origin' })
      if (!response.ok) continue
      const body = await response.json()
      const order = body?.data
      if (!order || typeof order !== 'object') continue
      return {
        id: order.id,
        currentStepVersion: order.currentStepVersion,
        tpService: order.data?.tpService ?? null,
      }
    } catch {
      // Sieťová chyba alebo neplatný JSON — skúsime ešte raz
    }
  }
  return null
}

// Mouseflow: verzia košíka zodpovedá WIZARD_VERSION (pôvodný v1, nový v2). _mfq je fronta, ktorú
// Mouseflow spracuje až po načítaní svojho skriptu — volanie je bezpečné aj keď sa nenačíta vôbec.
export function setMouseflowWizardVersion(variant: CheckoutVariant, target: { _mfq?: unknown[][] }): void {
  target._mfq = target._mfq || []
  target._mfq.push(['setVariable', 'wizardVersion', variant === 'new' ? 'v2' : 'v1'])
}
